module.exports = __webpack_public_path__ + "static/media/chart-column-solid-full.c107aa5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/chart-column-solid-full.svg
// module id = 2583
// module chunks = 0